<template>
    <v-container>
        <v-toolbar-title>SE locations</v-toolbar-title>
        <br>
        <v-data-table
            :headers="headers"
            :items="boxes"
            class="elevation-1"
            :search="search">
        
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
          color="success"
          outlined rounded
          :id="item.id"
          @click="openDialog(item)"
          >
          Complete
          <!-- <v-icon right style="margin: 2px" class="icon_style">
            check-circle-outline
          </v-icon> -->
        </v-btn>
      </template>
      </v-data-table>

      <v-dialog v-model="dialogComplete" width="30%">
            <v-card>
                <v-card-title class="headline footer" primary-title>
                Complete a location box
                </v-card-title>
                <v-alert v-if="errorMessage && !check"
                    border="bottom"
                    color="red"
                    type="error">
                    Please confirm your action first.
                </v-alert>
                <br />
                <v-card-text>
                    <div>
                        Are you sure you want to complete the location box?
                        By completing you ensure the box <b>{{this.currItem.locationCode}}</b> will be sent back to the warehouse.
                        <v-checkbox
                        v-model="check"
                        label="Yes, I'm sure"
                        />
                        <div v-if="check">
                            New code for this location:
                            <b>{{this.newLocation}}</b>
                        </div>
                    </div>

                </v-card-text>
                <v-divider></v-divider>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" outlined @click="complete()">Save</v-btn>
                    <v-btn color="error" outlined @click="close()">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
    
<script>
import axios from "axios";
export default {
    name: "SE location boxes",
    data: () => ({
        headers: [
            { text: "Type", value: "type" },
            { text: "Current location code", value: "locationCode" },
            { text: "Action", value: "actions" }
        ],
        boxes: [],
        search: "",
        dialogComplete: false,
        currItem: "",
        newLocation: "",
        check: false,
        errorMessage: false
    }),
    methods: {
        openDialog(item) {
            this.dialogComplete = true;
            this.currItem = item;
            this.formatNewLocationCode()
        },
        close() {
            this.dialogComplete = false
            this.errorMessage = false
            this.check = false
        },
        complete() {
            if (this.check) {
                this.errorMessage = false
                axios.put('api/boxlocation/'+this.currItem.id, {
                "type": this.currItem.type,
                "locationCode": this.newLocation
                })
                  .then(() => { 
                      this.getLocations()
                      this.dialogComplete = false
                  })
                  .catch(err => console.log(err))
            }
            else {
                this.errorMessage = true
            }
            
        },
        formatNewLocationCode(){
            var strVals = this.currItem.locationCode.replace(/\d/g,'')
            console.log(strVals);
            var numbers = parseInt(this.currItem.locationCode.replace(/\D/g,'')) + 1;
            var numbersStr = numbers.toString();
            var finalNum = numbersStr.padStart(5, "0");
            var finalNumStr = strVals+finalNum;

            this.newLocation = finalNumStr
        },
        getLocations() {
            axios.get('api/boxlocation')
                .then((response) => {
                    this.boxes = response.data;
                 })
                .catch(e => {
                this.errors.push(e)
                })
        }
    },
    mounted() {
        this.getLocations()
    }
}
</script>

<style>

</style>